const getSectionPermissions = (userCtx, writers, readers, mineSearchCallback) => {
  let canWrite = false;
  let canRead = false;
  let role = null;

  const { mine } = userCtx;

  if (mine) {
    const foundSection = mineSearchCallback(mine);
    if (foundSection && foundSection.role) {
      canWrite = canWrite || writers.includes(foundSection.role);
      canRead = canWrite || readers.includes(foundSection.role);
      role = foundSection.role;
    }
  }

  return { canWrite, canRead, role };
};

export const getStrategyPermissions = (userCtx, strategyId) => {
  const writers = ['admin', 'head', 'coordinator'];
  const readers = ['curator'];
  const strategySearchFunction = (mine) => mine.strategies && mine.strategies.find((p) => p.strategyId === parseInt(strategyId ?? '0'));

  return getSectionPermissions(userCtx, writers, readers, strategySearchFunction);
};

export const isProjectAdmin = ({ mine }, projId) => mine.projs && mine.projs.find((p) => (p.projId === parseInt(projId) || p.versionId === parseInt(projId)) && (p.role === 'head' || p.role === 'admin'));
export const isAnyProjectAdmin = ({ mine }) => mine.projs && mine.projs.find((p) => p.role === 'head' || p.role === 'admin');

export const getPolicyPermissions = (userCtx, policyId) => {
  const writers = ['admin', 'head', 'coordinator']; // разрешения у ролей такие же, как у команды СП?
  const readers = ['curator'];
  const policySearchFunction = (mine) => mine.policies && mine.policies.find((p) => p.policyId === parseInt(policyId ?? '0'));

  return getSectionPermissions(userCtx, writers, readers, policySearchFunction);
};

const getProjectPermissions = (userCtx, projId) => {
  const writers = ['admin', 'head'];
  const readers = ['employer', 'curator', 'approver'];
  projId = parseInt(projId ?? '0');
  const projectSearchFunction = (mine) => mine.projs && mine.projs.find((p) => p.projId === projId || p.versionId === projId);

  return getSectionPermissions(userCtx, writers, readers, projectSearchFunction);
};

export const getPortfolioPermissions = (userCtx, portfId) => {
  const writers = ['admin', 'head'];
  const readers = ['employer', 'curator', 'participant', 'participantAdmin'];
  portfId = parseInt(portfId ?? '0');
  const portfolioSearchFunction = (mine) => mine.portfolios && mine.portfolios.find((p) => p.portfId === portfId || p.versionId === portfId);

  return getSectionPermissions(userCtx, writers, readers, portfolioSearchFunction);
};

export const getProjectPerms = (userCtx, projId, strategyId, portfolioId, policyId) => {
  const { perms } = userCtx;
  const isAdminOrProjManagement = perms.includes('techAdmin') || perms.includes('projManagement');
  const isReviewGroup = perms.includes('reviewGroup');
  const isAccounting = perms.includes('accounting');

  const stratPerms = getStrategyPermissions(userCtx, strategyId);
  const policyPerms = getPolicyPermissions(userCtx, policyId);
  const portfPerms = getPortfolioPermissions(userCtx, portfolioId);
  const projPerms = getProjectPermissions(userCtx, projId);
  return {
    canWrite: isAdminOrProjManagement || stratPerms.canWrite || projPerms.canWrite,
    canRead: isAdminOrProjManagement || isReviewGroup || isAccounting || stratPerms.canRead || projPerms.canRead || portfPerms.canRead || portfPerms.canWrite || !!policyPerms.role, // перенести portfPerms.canWrite в canWrite, если у них должны быть такие же права, как у РСП
    strategyRole: stratPerms.role,
    policyRole: policyPerms.role,
    portfolioRole: portfPerms.role,
    projectRole: projPerms.role,
  };
};

export const isStratCurator = ({ mine }, stratId) => mine.strategies && mine.strategies.find((p) => p.strategyId === parseInt(stratId) && p.role === 'curator');
export const isStratAdmin = ({ mine }, stratId) => mine.strategies && mine.strategies.find((p) => p.strategyId === parseInt(stratId) && (p.role === 'head' || p.role === 'admin'));
export const isAnyStratAdmin = ({ mine }) => mine.strategies && mine.strategies.find((p) => p.role === 'head' || p.role === 'admin');

export const isPortfolioAdmin = ({ mine }, portfolioId) => mine.portfolios
    && mine.portfolios.find((p) => (p.portfId === parseInt(portfolioId) || p.versionId === parseInt(portfolioId)) && (p.role === 'head' || p.role === 'admin'));
export const isAnyPortfolioAdmin = ({ mine }) => mine.portfolios && mine.portfolios.find((p) => p.role === 'head' || p.role === 'admin');

export const isPolicyAdmin = ({ mine }, policyId) => mine.policies && mine.policies.find((p) => p.policyId === parseInt(policyId) && (p.role === 'head' || p.role === 'admin'));

export const isAdmin = (userCtx) => userCtx && userCtx.perms.find((p) => p === 'techAdmin' || p === 'projManagement');
export const isAdminRead = (userCtx) => userCtx && userCtx.perms.find((p) => p === 'techAdmin' || p === 'projManagement' || p === 'reviewGroup' || p === 'accounting');
export const isAdminReadRestricted = (userCtx) => userCtx && userCtx.perms.find((p) => p === 'techAdmin' || p === 'projManagement' || p === 'reviewGroup');
export const isAccounting = (userCtx) => userCtx && userCtx.perms.find((p) => p === 'accounting');
export const isTechAdmin = (userCtx) => userCtx && userCtx.perms.includes('techAdmin');
export const isModerator = (userCtx) => userCtx && userCtx.perms.includes('moderator');

export const isMediaCenter_tst = (userCtx) => userCtx && userCtx.perms.find((p) => p === 'mediaCenter');

// ПО/Админ ИС, руководитель СП, админ СП
export const isProjectCreator = (userCtx, stratId) => isAdmin(userCtx) || (
  userCtx.mine.strategies
  && userCtx.mine.strategies.find((p) => p.strategyId === parseInt(stratId) && (p.role === 'head' || p.role === 'admin'))
);
export const isStrategyTeam = (userCtx, stratId) => !!(!!userCtx?.mine && userCtx?.mine?.strategies && !!stratId && userCtx?.mine.strategies.find((p) => p.strategyId === parseInt(stratId)));
export const isPolicyTeam = (userCtx, policyId) => !!(!!userCtx?.mine && userCtx?.mine?.policies && !!policyId && userCtx?.mine.policies.find((p) => p.policyId === parseInt(policyId)));

export const isPortfolioTeam = (userCtx, portfolioId) => !!(!!userCtx?.mine && userCtx?.mine?.portfolios && !!portfolioId
    && userCtx?.mine.portfolios.find((p) => (p?.portfId === parseInt(portfolioId) || p?.versionId === parseInt(portfolioId))));
export const isProjectTeam = (userCtx, projId) => !!userCtx?.mine && (userCtx?.mine?.projs && !!projId && userCtx?.mine.projs.find((p) => (p?.projId === parseInt(projId) || p?.versionId === parseInt(projId))));

export const isCommandManagmentOrProjOffice = (userCtx, stratId, projId, portfolioId) => ((isStrategyTeam(userCtx, stratId))
      || (isPortfolioTeam(userCtx, portfolioId))
      || (isProjectTeam(userCtx, projId))
      || (userCtx?.perms && !!isAdmin(userCtx)));

export const isKpiAdmin = (perms) => perms && (perms.includes('techAdmin') || perms.includes('projManagement') || perms.includes('kpiAdmin') || perms.includes('reviewGroup'));
export const isAdminOrModerator = (perms) => perms && (perms.includes('techAdmin') || perms.includes('projManagement') || perms.includes('moderator'));
export const isAdminReadRestrictedOrModerator = (perms) => perms && (perms.includes('techAdmin') || perms.includes('projManagement') || perms.includes('reviewGroup') || perms.includes('moderator'));

export const hasPermsOnIndexesOrReceipts = (userCtx, context) => {
  return !!isAdminReadRestricted(userCtx) || !!isStrategyTeam(userCtx, context?.stratId) || !!isPortfolioTeam(userCtx, context?.portfolioId) || !!isProjectTeam(userCtx, context?.projId)
};


